import { render, staticRenderFns } from "./PrivacyManagement.vue?vue&type=template&id=371c4eb5&scoped=true"
import script from "./PrivacyManagement.vue?vue&type=script&lang=js"
export * from "./PrivacyManagement.vue?vue&type=script&lang=js"
import style0 from "./PrivacyManagement.vue?vue&type=style&index=0&id=371c4eb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-load_d49922f226348ede918ce6b4a43f88e2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371c4eb5",
  null
  
)

export default component.exports